module.exports = __webpack_public_path__ + "media/images/heroes/home-3-55a46fbde0c64c5c0dceb7e784c80db9.png";